<template>
  <v-container class="px-7" fluid>
    <v-row no-gutters align="center" justify="space-between" class="mb-3 mt-2">
      <v-col cols="12" sm="6">
        <h1 class="fs-20 font-weight-bold bluedarken--text">
          Dashboard {{ item.name }}
        </h1>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn color="primary" icon large>
          <v-icon
            class="icon-large icon-bold"
            color="bluedarken"
            @click="refresh"
          >
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row align="start" justify="space-between">
      <v-col cols="12" sm="12" md="9">
        <v-card :loading="loading" class="elevation-card rounded-10">
          <v-card-title>
            <!--              <v-icon color="primary" class="mr-2">-->
            <!--                mdi-web-->
            <!--              </v-icon>-->
            <div>
              <div class="fs-20 lh-24 font-weight-bold primary--text">
                Sponsorship
              </div>
              <div class="fs-12 font-weight-regular grey--text lh-15">
                by {{ item.name }}
              </div>
            </div>
            <v-spacer />
            <v-btn text>
              <v-img
                src="@/assets/images/icon-settings.png"
                width="16"
                height="16"
                class="mr-2"
                contain
              ></v-img>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </v-card-title>

          <dashboard-chart :item="item" />
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-row>
          <template v-if="loading">
            <v-col
              cols="12"
              sm="4"
              md="12"
              v-for="(stat, index) in stats"
              :key="stat.title + index"
              :class="{ 'pt-0': index === 0 }"
            >
              <v-skeleton-loader height="100" type="image" />
            </v-col>
          </template>

          <v-col
            v-else
            cols="12"
            sm="4"
            md="12"
            v-for="(stat, index) in stats"
            :key="index"
            :class="{ 'py-0': $vuetify.breakpoint.mdAndUp && index === 0 }"
          >
            <v-card
              class="py-3 fill-height px-3 align-center d-flex rounded-10 elevation-card"
            >
              <v-row dense align="center">
                <v-col cols="3">
                  <v-img
                    width="36"
                    height="36"
                    contain
                    :src="require(`@/assets/images/${stat.icon}.png`)"
                    class="mx-auto"
                  ></v-img>
                </v-col>
                <v-col cols="9">
                  <div class="fs-12 menuActive--text font-weight-bold">
                    {{ stat.title }}
                  </div>
                  <div class="primary--text fs-24 font-weight-bold">
                    {{ stat.count }}
                  </div>
                  <div class="fs-12 grey--text font-weight-bold">
                    Total
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-card :loading="loading" class="elevation-card rounded-12">
      <v-card-title>
        <div class="mr-2">
          <v-img
            src="@/assets/images/icon-file-text.png"
            width="20"
            height="20"
          />
        </div>
        <span class="fs-14 font-weight-bold bluedarken--text">
          Summary by {{ item.name }}
        </span>
        <v-spacer />
        <select-column-filter v-model="columnActive" :headers="headers" />
        <v-btn
          depressed
          dark
          color="menuActive"
          class="btn-medium"
          @click="download"
        >
          Download
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-simple-table class="nav-table">
          <template v-slot:default>
            <thead>
              <tr>
                <template v-for="(header, index) in headers">
                  <th
                    v-if="isHeaderSelected(header)"
                    :key="header.text"
                    class="white--text"
                    :class="{ [`text-${header.align}`]: true }"
                  >
                    <span>{{ header.text }}</span>
                    <filter-column
                      v-if="header.value !== 'action'"
                      :indexItem="index"
                      :field="header.value"
                      :listFilter="getFiltered(header.value, index)"
                      @sortAsc="getNestedSort"
                      @searchColumn="searchCln"
                      @filterItem="searchCln"
                    />
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredItems" :key="index">
                <template v-for="header in headers">
                  <td
                    v-if="isColumnSelected(header.value)"
                    :key="header.name"
                    :class="{
                      [header.tdClass]: true,
                      [`text-${header.align}`]: true
                    }"
                  >
                    <template v-if="header.value === 'action'">
                      <v-btn
                        text
                        color="primary"
                        class="text-capitalize font-weight-bold"
                        :to="toDetail(item)"
                      >
                        <v-img
                          src="@/assets/images/icon-doc.png"
                          width="16"
                          height="16"
                          class="mr-2"
                        />
                        Details
                      </v-btn>
                    </template>
                    <span v-else>
                      {{ header | tableRowValue(item) }}
                    </span>
                  </td>
                </template>
              </tr>
              <tr v-if="filteredItems.length" class="total">
                <td v-if="isHeaderSelectedByValue('name')">Total SN ID</td>
                <td v-if="isHeaderSelectedByValue('hospital')">
                  {{ totalHospital }}
                </td>
                <td v-if="isHeaderSelectedByValue('support_amount')">
                  {{ totalAmountOfSupport | toCurrencyWithoutSign }}
                </td>
                <td v-if="isHeaderSelectedByValue('ctr')">{{ totalCtr }} %</td>
                <td v-if="isHeaderSelectedByValue('average_support')"></td>
                <td
                  v-if="isHeaderSelectedByValue('action')"
                  class="text-center"
                >
                  <v-btn
                    text
                    color="primary"
                    class="text-capitalize font-weight-bold"
                    :to="toDetailAll"
                  >
                    <v-img
                      src="@/assets/images/icon-doc.png"
                      width="16"
                      height="16"
                      class="mr-2"
                    />
                    Details
                  </v-btn>
                </td>
              </tr>
              <tr v-if="!filteredItems.length">
                <td :colspan="headers.length" class="text-center">
                  {{ loading ? 'Loading...' : 'No data available' }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import DashboardChart from '@/components/SSHCF/DashboardChart';
import FilterColumn from '@/components/filterColumn';
import { mapState } from 'vuex';
import { exportToExcel } from '@/utils/helpers';
import { BIDRFormat, MIDRFormat, toCurrencyWithoutSign } from '@/mixins/filter';
import moment from 'moment';
import SelectColumnFilter from '@/components/SelectColumnFilter';

export default {
  props: {
    item: {}
  },
  components: { SelectColumnFilter, DashboardChart, FilterColumn },
  data: () => ({
    items: [],
    filter: null,
    columnActive: [],
    loading: false
  }),
  computed: {
    ...mapState('sshcf', {
      dashboard: 'dashboard',
      dashFilter: 'filter'
    }),
    headers() {
      return [
        {
          text: this.item.name,
          align: 'left',
          value: 'name'
        },
        {
          text: 'Number of Hospital',
          align: 'left',
          value: 'hospital'
        },
        {
          text: 'Amount of Support',
          align: 'left',
          value: 'support_amount',
          formatter: toCurrencyWithoutSign
        },
        {
          text: '% Ctr',
          align: 'left',
          value: 'ctr'
        },
        {
          text: 'Average of Support',
          align: 'left',
          value: 'average_support',
          formatter: toCurrencyWithoutSign
        },
        {
          text: 'Progress',
          align: 'center',
          value: 'action'
        }
      ];
    },
    stats() {
      return [
        {
          title: 'Number of Hospital',
          count: this.dashboard.total_hospital,
          icon: 'icon-amount-hospital'
        },
        {
          title: 'Amount of Support',
          count: `${BIDRFormat(this.dashboard.total_support_amount || 0)} BIDR`,
          icon: 'icon-amount-support'
        },
        {
          title: 'Average of Support',
          count: `${MIDRFormat(
            this.dashboard.total_average_support || 0
          )} MIDR`,
          icon: 'icon-average-support'
        }
      ];
    },
    totalHospital() {
      return this.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.hospital;
      }, 0);
    },
    totalAmountOfSupport() {
      return this.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.support_amount;
      }, 0);
    },
    totalAverageOfSupport() {
      return this.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.average_support;
      }, 0);
    },
    totalCtr() {
      return this.items
        .reduce((previousValue, currentValue) => {
          return previousValue + currentValue.ctr;
        }, 0)
        .toFixed(2);
    },
    filteredItems() {
      return this.getFilteredItems();
    },
    isSelectedAll: {
      get() {
        return this.headers
          ? this.columnActive.length === this.headers.length
          : false;
      },
      set(value) {
        const selected = [];

        if (value) {
          this.headers.forEach(function(user) {
            selected.push(user);
          });
        }

        this.columnActive = selected;
      }
    },
    headersWithoutAction() {
      return this.headers.filter(item => item.value !== 'action');
    },
    toDetailAll() {
      const { yearStart, yearEnd } = this.dashFilter;
      return `/sshcf/sponsorship/reports?filter_year_start=${yearStart}&filter_year_end=${yearEnd}`;
    }
  },
  watch: {
    item: {
      immediate: true,
      async handler(val) {
        await this.fetch({
          groupBy: val.name.toLowerCase()
        });
        this.selectAllColumn();
      }
    },
    dashFilter: {
      deep: true,
      handler(filter) {
        if (filter.isSubmit) {
          this.refresh();
        }

        if (filter.isDownload) {
          this.download();
        }
      }
    }
  },
  created() {
    this.selectAllColumn();
  },
  methods: {
    async refresh() {
      await this.fetch();
      this.selectAllColumn();
    },
    selectAllColumn() {
      this.columnActive = this.headers;
    },
    async fetch(params = {}) {
      this.loading = true;
      const res = await this.$store.dispatch('sshcf/getDashboard', {
        groupBy: this.item.name.toLowerCase(),
        house: this.dashFilter.house || '',
        status: this.dashFilter.status.join(','),
        region: this.dashFilter.region || '',
        district: this.dashFilter.district || '',
        start_year: this.dashFilter.yearStart || '',
        end_year: this.dashFilter.yearEnd || '',
        ...params
      });
      this.loading = false;
      this.items = res.data.result;

      this.$store.commit('sshcf/set', {
        ...this.filter,
        isSubmit: false
      });
    },
    toggleSelectAll() {
      this.isSelectAll = !this.isSelectAll;
    },
    isHeaderSelected(header) {
      return this.columnActive.map(item => item.value).includes(header.value);
    },
    isHeaderSelectedByValue(value) {
      return this.columnActive.map(item => item.value).includes(value);
    },
    isColumnSelected(name) {
      return this.columnActive.filter(item => item.value === name).length > 0;
    },
    getAscSort(obj) {
      this.items.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.items);
    },
    searchCln(obj) {
      this.filter = obj;
    },
    getFilteredItems() {
      const obj = this.filter;
      let arr = this.items;

      if (!obj) return arr;

      let nameField = obj.fieldName;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      let result = [];
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        result = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(String(a[nameField]));
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else {
          result = this.items;
        }
      }

      return result;
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        return Object.keys(
          this.items.reduce((result, arr) => {
            result[arr[name]] = [...(result[arr[name]] || []), arr];
            return result;
          }, {})
        );
      } else {
        let nameField = name.split('.');
        return Object.keys(
          this.items.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {})
        );
      }
    },
    async download() {
      const headers = this.headers.filter(item => item.value !== 'action');
      const columns = headers.map(item => item.text);
      const items = this.filteredItems.map(item =>
        headers.map(header =>
          header.formatter
            ? header.formatter(item[header.value])
            : item[header.value]
        )
      );
      items.push([
        'Total SN ID',
        this.totalHospital,
        this.totalAmountOfSupport,
        this.totalCtr
      ]);

      const date = moment().format('YYYY-MM-DD-HHmmss');

      await exportToExcel(
        columns,
        items,
        `Dashboard-Reports-Summary-${this.item.name}-${date}`
      );

      this.$store.commit('sshcf/set', {
        ...this.filter,
        isDownload: false
      });
    },
    toDetail(item) {
      let key = this.item.name.toLowerCase();
      const { yearStart, yearEnd } = this.dashFilter;
      return `/sshcf/sponsorship/reports?filter_by=${key}&filter_value=${item.name}&filter_year_start=${yearStart}&filter_year_end=${yearEnd}`;
    }
  }
};
</script>
